import { LoadingGif } from 'assets';
import { Method } from 'axios';
import IconButton from 'components/IconButton';
import callApi from 'lib/callApi';
import React, { useState, useEffect, ReactNode } from 'react';

interface Props {
  buttonId: string;
  iconClass: string;
  tooltip: ReactNode;
  downloadUrl: string;
  method: Method;
  fileName: string;
  disabled?: boolean;
  className?: string;
  urlParams?: any;
  data?: any;
  headers?: any;
  onSuccessCallback?: () => void;
  onFailureCallback?: (message) => void;
}

const FileDownloaderButton: React.FC<Props> = ({
  buttonId,
  iconClass,
  tooltip,
  downloadUrl,
  method,
  fileName,
  disabled = false,
  className,
  urlParams = {},
  data = null,
  headers = null,
  onSuccessCallback,
  onFailureCallback,
}) => {
  const [loading, setLoading] = useState(false);

  const downloadFile = async () => {
    if (downloadUrl) {
      callApi(downloadUrl, method, urlParams, data, headers)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            var data = res.data;
            setLoading(false);
            var blob = new Blob([data], { type: 'text/csv' });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            if (onSuccessCallback) onSuccessCallback();
          } else {
            setLoading(false);
            console.error({
              function: 'downloadFile',
              error: `Unexpected response: ${res.status}`,
              res,
            });

            if (onFailureCallback)
              onFailureCallback('Failed to download file.');
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error({
            function: 'downloadFile',
            error: err,
          });
          if (onFailureCallback) onFailureCallback('Failed to download file.');
        });
    }
  };

  const handleClick = () => {
    setLoading(true);
    downloadFile();
  };

  useEffect(() => {
    setLoading(false);
  }, [downloadUrl]);

  const spinner = (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ width: '26px', height: '26px' }}
    >
      <img className="bg-img x-sm" src={LoadingGif} alt="downloading..." />
    </div>
  );

  return (
    <>
      {loading ? (
        <IconButton
          id={buttonId}
          iconElement={spinner}
          tooltip="downloading..."
          disabled={true}
          size="sm"
          onClick={() => {
            /* do nothing */
          }}
          cssClass={className}
        />
      ) : (
        <IconButton
          id={buttonId}
          disabled={disabled}
          iconClass={iconClass}
          tooltip={tooltip}
          onClick={handleClick}
          cssClass={className}
        />
      )}
    </>
  );
};

export default FileDownloaderButton;
